import centerIconImage from '@/assets/my-centers-marker.png';

const ICON_SIZE = 40;

export const createCenterIcon = (): google.maps.Icon => {
  return {
    url: centerIconImage,
    scaledSize: new google.maps.Size(ICON_SIZE, ICON_SIZE),
    anchor: new google.maps.Point(ICON_SIZE / 2, ICON_SIZE / 2),
    origin: new google.maps.Point(0, 0)
  };
};
